import React, { useState, useRef } from 'react';

const FloatingPromoVideo = ({ inline = false, videoSrc = "/epicfinal_Promo.mp4" }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const videoRef = useRef(null);

    if (!isVisible) return null;

    const toggleExpand = () => {
        if (!isExpanded) {
            setIsExpanded(true);
            if (videoRef.current) {
                videoRef.current.play();
            }
        }
    };

    const closeVideo = (e) => {
        e.stopPropagation();
        setIsExpanded(false);
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    };

    const handleDismiss = (e) => {
        e.stopPropagation();
        setIsVisible(false);
    };

    const inlineStyle = {
        position: isExpanded ? 'absolute' : 'relative',
        zIndex: 999,
        left: 0,
        top: 0
    };

    return (
        <div 
            className="floating-promo-video-wrapper"
            style={{
                position: inline ? 'relative' : 'fixed',
                ...(inline ? {} : { left: '20px', top: '320px', zIndex: 9999 }),
                width: '90px',
                height: '90px',
                marginTop: inline ? '20px' : '0'
            }}
        >
            {/* Dismiss button when not expanded */}
            {!isExpanded && (
                <button
                    onClick={handleDismiss}
                    style={{
                        position: 'absolute',
                        top: '-4px',
                        right: '-4px',
                        background: '#dc3545',
                        color: 'white',
                        border: '2px solid white',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        zIndex: 100,
                        padding: 0,
                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                    }}
                    title="Close Video"
                >
                    <i className="las la-times"></i>
                </button>
            )}

            <div 
                className={`floating-promo-video ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpand}
                style={{
                    position: isExpanded ? 'absolute' : 'relative',
                    left: 0,
                    top: 0,
                    zIndex: 999,
                    cursor: isExpanded ? 'default' : 'pointer',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    width: isExpanded ? 'min(85vw, 300px)' : '90px',
                    height: isExpanded ? 'auto' : '90px',
                    borderRadius: isExpanded ? '12px' : '50%',
                    overflow: 'hidden',
                    boxShadow: isExpanded ? '0 12px 30px rgba(0,0,0,0.3)' : '0 8px 24px rgba(0,0,0,0.2)',
                    backgroundColor: '#000',
                    border: isExpanded ? '2px solid #0078a8' : '3px solid #0078a8',
                }}
            >
                {isExpanded && (
                <button 
                    onClick={closeVideo}
                    style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        zIndex: 10,
                        background: 'rgba(0,0,0,0.6)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        fontSize: '16px'
                    }}
                >
                    <i className="las la-times"></i>
                </button>
            )}

            <div style={{
                position: 'relative',
                width: '100%',
                height: isExpanded ? 'auto' : '100%', // use auto height when expanded
                display: 'flex'
            }}>
                <video 
                    ref={videoRef}
                    src={videoSrc}
                    muted={false}
                    loop
                    playsInline
                    controls={isExpanded} // add controls when expanded
                    style={{
                        width: '100%',
                        height: isExpanded ? 'auto' : '100%',
                        objectFit: 'cover',
                        pointerEvents: isExpanded ? 'auto' : 'none'
                    }}
                />
                
                {/* Play icon overlay when not expanded */}
                {!isExpanded && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(0,0,0,0.3)',
                        transition: 'opacity 0.3s ease'
                    }}>
                        <i className="las la-play" style={{ color: 'white', fontSize: '32px', opacity: 0.9 }}></i>
                    </div>
                )}
            </div>
            
                {/* Hover tooltip for unexpanded state */}
                {!isExpanded && (
                    <style>{`
                        .floating-promo-video:hover {
                            transform: scale(1.05);
                            box-shadow: 0 12px 28px rgba(0,0,0,0.3);
                        }
                        .floating-promo-video:hover i {
                            transform: scale(1.1);
                        }
                        @media (max-width: 768px) {
                            .floating-promo-video-wrapper {
                                display: none !important;
                            }
                        }
                    `}</style>
                )}
            </div>
        </div>
    );
};

export default FloatingPromoVideo;
